import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';

class RightNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { historyTitle, historyList, digitalListAd, digitalHardAd },
        } = this.props;

        return (
            <div className={styles.right_box}>
                <Chip id="230182" type="struct" title="历史标题" groupName="历史" content={historyTitle}>
                    <NewsTitle size="short" />
                </Chip>
                <Chip
                    id="195855"
                    type="recommend"
                    title="历史列表"
                    groupName="历史"
                    content={historyList}
                    translate="handleNewsData">
                    <NewsList hasTitle size="short" ad={digitalListAd} />
                </Chip>
                <NoSSR>
                    <Ad content={digitalHardAd} styleName={styles.dbox} />
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(RightNewsBox);
